module.exports = __webpack_public_path__ + "static/media/level-2-anim.a07b1bb2.gif";